import * as React from 'react';

export const PrivacyIcon: React.FunctionComponent = () => {
  return (
    <svg width='14' height='16' viewBox='0 0 14 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M7 0C4.8 0 3 1.8 3 4V5H1C0.4 5 0 5.4 0 6V15C0 15.6 0.4 16 1 16H13C13.6 16 14 15.6 14 15V6C14 5.4 13.6 5 13 5H11V4C11 1.8 9.2 0 7 0ZM8 11.7V13H6V11.7C5.4 11.4 5 10.7 5 10C5 8.9 5.9 8 7 8C8.1 8 9 8.9 9 10C9 10.7 8.6 11.4 8 11.7ZM9 5H5V4C5 2.9 5.9 2 7 2C8.1 2 9 2.9 9 4V5Z' />
    </svg>
  );
};
